import Reveal from "@/components/Reveal";
import { PROMO_PROGRESSION } from "@/components/Hero";

export default function BeforeAfter() {
  return (
    <section id="results" className="grain relative overflow-hidden bg-[#0F1E19] py-20 text-[#FBF9F4] lg:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <Reveal>
          <p className="text-sm font-bold tracking-[0.3em] text-[#9BD8BC]">النتائج تتحدث</p>
          <h2 className="font-display mt-3 text-2xl font-black sm:text-3xl lg:text-4xl">
            قبل <span className="text-[#D4AF37]">/</span> بعد
          </h2>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-[#FBF9F4]/65 sm:text-base">
            مظهر الأظافر قبل الاستخدام وبعد المواظبة على طقوس العناية ببخاخ يوكيور
            بروفيشينال.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-6 md:grid-cols-2">
          <Reveal delay={0.05}>
            <figure
              className="group relative overflow-hidden rounded-3xl border border-[#FBF9F4]/10 bg-black"
              data-testid="before-image"
            >
              <div className="aspect-[4/5] w-full overflow-hidden">
                <img
                  src="/before-nail.jpg"
                  alt="مظهر الظفر قبل الاستخدام"
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <figcaption className="absolute right-4 top-4 rounded-full bg-[#E65A6B] px-4 py-1.5 text-sm font-black text-white shadow-lg">
                قبل
              </figcaption>
            </figure>
          </Reveal>
          <Reveal delay={0.15}>
            <figure
              className="group relative overflow-hidden rounded-3xl border border-[#FBF9F4]/10 bg-black"
              data-testid="after-image"
            >
              <div className="aspect-[4/5] w-full overflow-hidden">
                <img
                  src="/after-nail.jpg"
                  alt="مظهر الظفر بعد المواظبة على العناية"
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <figcaption className="absolute right-4 top-4 rounded-full bg-[#2E9E6B] px-4 py-1.5 text-sm font-black text-white shadow-lg">
                بعد
              </figcaption>
            </figure>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <div className="mt-8 overflow-hidden rounded-3xl border border-[#FBF9F4]/10">
            <img
              src={PROMO_PROGRESSION}
              alt="مراحل تحسّن مظهر الظفر مع بخاخ يوكيور"
              loading="lazy"
              className="w-full object-cover"
              data-testid="progression-image"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
